import axios from "axios";

export const fetchTrainerIntakeBatches = () =>
  axios.get("/api/trainer_inventory/intake_batches");

export const fetchTrainerIntakeRows = (batchId) =>
  axios.get(`/api/trainer_inventory/intake_batches/${batchId}/rows`);

export const createTrainerIntakeBatch = (payload) =>
  axios.post("/api/trainer_inventory/intake_batches", payload);

export const saveTrainerBatchCost = (batchId, payload) =>
  axios.put(`/api/trainer_inventory/intake_batches/${batchId}/batch_cost`, payload);

export const fetchTrainerBatchCostAudit = (batchId) =>
  axios.get(`/api/trainer_inventory/intake_batches/${batchId}/batch_cost/audit`);

export const createTrainerIntakeRow = (batchId, payload) =>
  axios.post(`/api/trainer_inventory/intake_batches/${batchId}/rows`, payload);

export const createQuickTrainerIntakeRow = (batchId, payload) =>
  axios.post(`/api/trainer_inventory/intake_batches/${batchId}/quick_rows`, payload);


export const previewQuickTrainerBulk = (batchId, rows) =>
  axios.post(`/api/trainer_inventory/intake_batches/${batchId}/quick_bulk/preview`, { rows });

export const commitQuickTrainerBulk = (batchId, payload) =>
  axios.post(`/api/trainer_inventory/intake_batches/${batchId}/quick_bulk/commit`, payload);

export const correctQuickTrainerIntakeRow = (batchId, rowId, payload) =>
  axios.patch(`/api/trainer_inventory/intake_batches/${batchId}/quick_rows/${rowId}`, payload);

export const voidQuickTrainerIntakeRow = (batchId, rowId, payload) =>
  axios.delete(`/api/trainer_inventory/intake_batches/${batchId}/quick_rows/${rowId}`, { data: payload });

export const confirmReceivedQuickRowNearMint = (batchId, rowId, payload) =>
  axios.post(`/api/trainer_inventory/intake_batches/${batchId}/quick_rows/${rowId}/confirm_near_mint`, payload);

export const fetchQuickTrainerIntakeAudit = (batchId, rowId) =>
  axios.get(`/api/trainer_inventory/intake_batches/${batchId}/quick_rows/${rowId}/audit`);

export const finaliseQuickTrainerIntake = (batchId, payload) =>
  axios.post(`/api/trainer_inventory/intake_batches/${batchId}/quick_finalise`, payload);

export const finaliseTrainerIntakeBatch = (batchId) =>
  axios.post(`/api/trainer_inventory/intake_batches/${batchId}/finalise`);


export const applyTrainerIntakeRowAllocation = (intakeRowId) =>
  axios.post(`/api/trainer_inventory/intake_rows/${intakeRowId}/apply_allocation`);

export const applyTrainerIntakeBatchAllocations = (batchId) =>
  axios.post(`/api/trainer_inventory/intake_batches/${batchId}/apply_allocations`);

export const refreshTrainerIntakeEbayPreview = (intakeRowId, listingRole = "single") =>
  axios.post(`/api/trainer_inventory/intake_rows/${intakeRowId}/ebay_refresh_preview`, {
    listing_role: listingRole,
  });

export const applyTrainerIntakeEbayProjection = (intakeRowId, listingRole = "single") =>
  axios.post(`/api/trainer_inventory/intake_rows/${intakeRowId}/ebay_apply_projection`, {
    approved: true,
    listing_role: listingRole,
  });

export const fetchTrainerEbayErrorLogs = (params = {}) =>
  axios.get("/api/trainer_inventory/ebay_error_logs", {
    params: {
      source_module: "trainer_inventory",
      unresolved_only: 1,
      limit: 25,
      ...params,
    },
  });

export const resolveTrainerEbayErrorLog = (errorLogId, resolutionNotes = "") =>
  axios.post(`/api/trainer_inventory/ebay_error_logs/${errorLogId}/resolve`, {
    resolution_notes: resolutionNotes,
  });
export const fetchTrainerAllocationContext = (params = {}) =>
  axios.get("/api/trainer_inventory/allocation_context", { params });

export const refreshTrainerAllocationStoreQty = (payload = {}) =>
  axios.post("/api/trainer_inventory/allocation_context/refresh_store_qty", payload);

// FC246/1279: read-only cross-batch receipt-specific queue and preview.
export const fetchAwaitingTrainerAllocationQueue = (afterId = 0, limit = 150) =>
  axios.get("/api/trainer_inventory/deferred_allocations/queue", { params: { after_id: afterId, limit } });

export const previewTrainerDeferredAllocation = (rowId, payload) =>
  axios.post(`/api/trainer_inventory/intake_rows/${rowId}/deferred_allocations/preview`, payload);

export const applyTrainerDeferredAllocation = (rowId, payload) =>
  axios.post(`/api/trainer_inventory/intake_rows/${rowId}/deferred_allocations`, payload);

export const fetchTrainerDeferredAllocationHistory = (rowId) =>
  axios.get(`/api/trainer_inventory/intake_rows/${rowId}/deferred_allocations`);

// FC246/#1281: deferred event-level eBay reconciliation. No background approvals.
export const fetchDeferredTrainerEbayQueue = (afterId = 0) =>
  axios.get("/api/trainer_inventory/deferred_ebay", { params: { after_id: afterId } });

export const fetchDeferredTrainerEbayStatus = (eventId, role) =>
  axios.get(`/api/trainer_inventory/deferred_ebay/${eventId}/${role}`);

export const previewDeferredTrainerEbay = (eventId, role) =>
  axios.post(`/api/trainer_inventory/deferred_ebay/${eventId}/${role}/preview`, {});

export const approveDeferredTrainerEbay = (eventId, role, previewToken) =>
  axios.post(`/api/trainer_inventory/deferred_ebay/${eventId}/${role}/approve`, {
    approved: true, preview_token: previewToken,
  });


// FC247 SKU verification operator endpoints; requests do not perform eBay writes
// except the separately confirmed approve call.
export const fetchSkuVerificationTasks = (afterId = 0, status = "") =>
  axios.get("/api/trainer_inventory/sku_verification/tasks", { params: { after_id: afterId, limit: 50, ...(status ? { status } : {}) } });
export const fetchSkuVerificationTask = (id) =>
  axios.get(`/api/trainer_inventory/sku_verification/tasks/${id}`);
export const buildSkuVerificationQueue = () =>
  axios.post("/api/trainer_inventory/sku_verification/tasks/build", {});
export const previewSkuVerificationTask = (id, version) =>
  axios.post(`/api/trainer_inventory/sku_verification/tasks/${id}/preview`, { expected_version: version });
export const approveSkuVerificationTask = (id, payload) =>
  axios.post(`/api/trainer_inventory/sku_verification/tasks/${id}/approve`, payload);
export const diagnoseSkuRecovery = (id, token) =>
  axios.get(`/api/trainer_inventory/recovery/sku_task/${id}`, { headers: { "X-FC247-Recovery-Token": token } });

// FC247-13 operator handoff. All writes are explicit, local and audited.
export const fetchReceivedSkuWorklist = (afterId = 0) =>
  axios.get("/api/trainer_inventory/sku_verification/received_worklist", { params: { after_id: afterId, limit: 50 } });
export const fetchReceiptListingCandidates = (id, afterId = 0) =>
  axios.get(`/api/trainer_inventory/intake_rows/${id}/listing_candidates`, { params: { after_id: afterId, limit: 25 } });
export const confirmReceiptExactListing = (id, payload) =>
  axios.post(`/api/trainer_inventory/intake_rows/${id}/exact_listing/confirm`, payload);
export const previewReceiptAllocation = (id, payload) =>
  axios.post(`/api/trainer_inventory/intake_rows/${id}/allocation_resolution/preview`, payload);
export const confirmReceiptAllocation = (id, payload) =>
  axios.post(`/api/trainer_inventory/intake_rows/${id}/allocation_resolution/confirm`, payload);
